<template>
    <div id="app">
        <div class="config-error-page" v-if="$store.state.common.configError || $store.state.common.pageLoadError">
            <div class="config-error-card">
                <div class="config-error-icon">!</div>
                <div class="config-error-title">{{ $store.state.common.pageLoadError ? '页面加载失败，请重新加载' : '配置异常' }}</div>
                <button class="config-error-retry" type="button" @click="reloadPage">重新加载</button>
            </div>
        </div>
        <div class="init-loading" v-else-if="!$store.getters.initialization">
            <div class="init-loading-spinner"></div>
            <div class="init-loading-text">加载中...</div>
        </div>
        <template v-else>
            <div class="current-scene" v-if="$store.state.common.env != 'PRO'">
                当前环境: {{ $store.state.common.env }}-{{ $store.state.common.currentScene }}
            </div>
            <keep-alive v-if="reloadStatus && $route.meta.keepAlive">
                <router-view class="Router" />
            </keep-alive>
            <router-view class="Router" v-if="reloadStatus && !$route.meta.keepAlive" />
        <!-- <transition :name="transitionName">
            <keep-alive>
                <router-view class="Router"
                             v-if="reloadStatus && $route.meta.keepAlive" />
            </keep-alive>
        </transition>
        <transition :name="transitionName">
            <router-view class="Router"
                         v-if="reloadStatus && !$route.meta.keepAlive" />
        </transition> -->
            <template v-if="openCSOL != null && showCSOL != null">
                <div class="cs-ol" v-if="openCSOL" v-show="showCSOL">
                    <div class="iphone-x-adaptation">
                        <OrderBtn />
                        <CustomerServiceBtn />
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import OrderBtn from '@/components/order/btn.vue';
import CustomerServiceBtn from '@/components/customerService/btn.vue';
import {
    PAGE_ROOT,
    PAGE_MAIN_MOVIE,
    PAGE_CINEMA_INFO,
    PAGE_MOVIE_SEAT_SELECTION,
    PAGE_PAY,
    PAGE_WECHAT_PAY,
    PAGE_CUSTOMER_SERVICE,
    PAGE_TICKET_TYPE,
    PAGE_ORDER_LIST,
    PAGE_ORDER_INFO,
    PAGE_ORDER_BID,
    PAGE_PAY_CENTER_PAGE,
    PAGE_SET_CITY,
    PAGE_COUPON_LIST,
    PAGE_COUPON_SELECT,
    PAGE_MAP,
    PAGE_APPLY_SUPPLIER,
    PAGE_AGREEMENT_REFUND,
} from 'page';
export default {
    name: 'App',
    data() {
        return {
            reloadStatus: true,
            transitionName: 'slide-left', // 默认动态路由变化为slide-right
        };
    },
    components: {
        OrderBtn,
        CustomerServiceBtn,
    },
    created() {
        if (this.isReloadApp) {
            this.$store.commit('startApp');
        }
        window.onload = () => {
            this.$store.commit('setBodyCssText', document.body.style.cssText);
        };
    },
    computed: {
        isReloadApp() {
            return this.$store.state.common.isReloadApp;
        },
        openCSOL() {
            return !!this.$store.state.common.platformId;
        },
        showCSOL() {
            let result = true;
            let hideCSOL = [
                PAGE_ROOT,
                PAGE_MAIN_MOVIE,
                PAGE_CINEMA_INFO,
                PAGE_SET_CITY,
                PAGE_MOVIE_SEAT_SELECTION,
                PAGE_PAY,
                PAGE_WECHAT_PAY,
                PAGE_CUSTOMER_SERVICE,
                PAGE_TICKET_TYPE,
                PAGE_ORDER_LIST,
                PAGE_ORDER_INFO,
                PAGE_ORDER_BID,
                PAGE_PAY_CENTER_PAGE,
                PAGE_COUPON_LIST,
                PAGE_COUPON_SELECT,
                PAGE_MAP,
                PAGE_APPLY_SUPPLIER,
                PAGE_AGREEMENT_REFUND,
            ];
            if (hideCSOL.indexOf(this.$route.path) > -1) {
                result = false;
            }
            return result;
        },
    },
    watch: {
        isReloadApp(val) {
            if (val) {
                console.log('app 重载开始');
                this.reloadStatus = false;
                this.$nextTick(() => {
                    console.log('app 重载结束');
                    console.log(this.$route);
                    console.log(this.$router);
                    this.$store.commit('startApp');
                    this.reloadStatus = true;
                    this.$forceUpdate();
                });
            }
        },
        $route(to, from) {
            if ((from.query.ct || 0) == 0) {
                this.transitionName = 'slide-left';
            } else if ((to.query.ct || 0) > (from.query.ct || 0)) {
                this.transitionName = 'slide-left';
            } else {
                this.transitionName = 'slide-right';
            }
        },
    },
    methods: {
        reloadPage() {
            if (this.$store.state.common.pageLoadError) {
                // 初次导航失败时 currentRoute 仍是 /，重试必须保留目标页面和渠道参数。
                const pending = this.$router.history.pending;
                const url = new URL(pending ? pending.fullPath : window.location.href, window.location.origin);
                url.searchParams.set('_reload', Date.now().toString());
                window.location.replace(url.href);
            } else {
                window.location.reload();
            }
        },
    },
};
</script>

<style lang="less">
@import url('~@/lib/base.less');
* {
    padding: 0;
    margin: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    position: relative;
}
div {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
body,
html {
    width: 100%;
    height: 100%;
    background: #f6f6f6;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f6f6f6;
}
.config-error-page {
    position: fixed;
    z-index: 10000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: .pxToRem(40) [];
    background: #f6f6f6;
    box-sizing: border-box;
}
.config-error-card {
    width: 100%;
    max-width: .pxToRem(620) [];
    padding: .pxToRem(64) [] .pxToRem(40) [];
    text-align: center;
    background: #ffffff;
    border-radius: .pxToRem(24) [];
    box-shadow: 0 .pxToRem(12) [] .pxToRem(40) [] rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
}
.config-error-icon {
    width: .pxToRem(88) [];
    height: .pxToRem(88) [];
    margin: 0 auto .pxToRem(28) [];
    color: #ffffff;
    font-size: .pxToRem(56) [];
    line-height: .pxToRem(88) [];
    border-radius: 50%;
    background: #e31d2b;
}
.config-error-title {
    color: #222222;
    font-size: .pxToRem(34) [];
    font-weight: 600;
}
.config-error-retry {
    min-width: .pxToRem(220) [];
    height: .pxToRem(76) [];
    margin-top: .pxToRem(40) [];
    color: #ffffff;
    font-size: .pxToRem(28) [];
    border: 0;
    border-radius: .pxToRem(38) [];
    background: #e31d2b;
}
.init-loading {
    position: fixed;
    z-index: 10000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f6f6f6;
}
.init-loading-spinner {
    width: .pxToRem(60) [];
    height: .pxToRem(60) [];
    border: 3px solid #e0e0e0;
    border-top-color: #e31d2b;
    border-radius: 50%;
    animation: init-spin 0.8s linear infinite;
}
.init-loading-text {
    margin-top: .pxToRem(20) [];
    color: #999999;
    font-size: .pxToRem(28) [];
}
@keyframes init-spin {
    to { transform: rotate(360deg); }
}
.cs-ol {
    position: fixed;
    right: .pxToRem(30) [];
    bottom: .pxToRem(230) [];
    pointer-events: none;
    z-index: 100;
    .share-component {
        .share {
            padding-bottom: @tabbarHeight;
        }
    }
}
.page {
    position: relative;
}
.flex {
    display: flex;
    align-items: center;
}
.bold {
    font-weight: bold;
}
.textover {
    display: -webkit-box;
    word-break: break-all;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
.textline {
    text-decoration: line-through;
}
.img {
    line-height: 0;
}
.weui-tabbar {
    z-index: 0 !important;
}
input {
    border: none;
    outline: none;
}
// swiper 自适应高修复
.swiper-container-autoheight .swiper-slide {
    height: 1px !important;
}
.swiper-container-autoheight .swiper-slide-active {
    height: auto !important;
}
// mint-ui 样式修改
.mint-msgbox {
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    backface-visibility: visible;
    -webkit-backface-visibility: visible;
    .mint-msgbox-content {
        padding: .pxToRem(40) [] .pxToRem(32) [];
        .mint-msgbox-message {
            font-size: .pxToRem(28) [];
            line-height: .pxToRem(36) [];
            color: #333333;
        }
    }
    .mint-msgbox-btns {
        .mint-msgbox-btn {
            font-size: .pxToRem(32) [];
            &.mint-msgbox-confirm {
                color: #3cc51f;
            }
            &.mint-msgbox-cancel {
                color: #999999;
            }
        }
    }
}
.mint-indicator-wrapper {
    z-index: 100;
}
.Router {
    position: absolute;
    width: 100%;
    top: 0px;
    transition: all 0.3s ease;
}
.slide-left-enter,
.slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(100%, 0);
    transform: translate(100%, 0);
}
.slide-left-leave-active,
.slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-100%, 0);
    transform: translate(-100% 0);
}
// iPhone 11 Pro
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .iphone-x-adaptation {
        padding-bottom: @tabbarSecurityHeight;
    }
    .iphone-x-adaptation-margin-bottom {
        margin-bottom: @tabbarSecurityHeight;
    }
}
// iPhone 11
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .iphone-x-adaptation {
        padding-bottom: @tabbarSecurityHeight;
    }
    .iphone-x-adaptation-margin-bottom {
        margin-bottom: @tabbarSecurityHeight;
    }
}
// iPhone 11 Pro Max
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .iphone-x-adaptation {
        padding-bottom: @tabbarSecurityHeight;
    }
    .iphone-x-adaptation-margin-bottom {
        margin-bottom: @tabbarSecurityHeight;
    }
}
// iPhone 12 and iPhone 12 Pro
@media only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
    .iphone-x-adaptation {
        padding-bottom: @tabbarSecurityHeight;
    }
    .iphone-x-adaptation-margin-bottom {
        margin-bottom: @tabbarSecurityHeight;
    }
}
// iPhone 12 Pro Max
@media only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
    .iphone-x-adaptation {
        padding-bottom: @tabbarSecurityHeight;
    }
    .iphone-x-adaptation-margin-bottom {
        margin-bottom: @tabbarSecurityHeight;
    }
}
</style>
<style lang="less" scoped>
.current-scene {
    position: fixed;
    top: 10px;
    right: 20px;
    background: rgba(0, 0, 0, 0.2);
    padding: 5px;
    z-index: 9999;
    pointer-events: none;
    color: white;
    font-size: 12px;
    border-radius: 3px;
}
</style>
